// cargoCalculations.js
export function calculateCargoFigures(shipFig, blFig) {
  const result = {
    diff: 0,
    percent: 0,
    date: null,
    time: null,
  };

  // Sätt differensen
  result.diff = shipFig - blFig;

  // Beräkna procent om båda värden finns
  if (shipFig !== 0 && blFig !== 0) {
    result.percent = Math.abs((shipFig - blFig) / shipFig) * 100;

    const now = new Date();
    result.date = now.toISOString().split("T")[0]; // YYYY-MM-DD
    result.time = now.toISOString().split("T")[1].slice(0, 5); // hh:mm
  }

  return result;
}
